<template>
  <div class="wrap">
    <h3 class="title">用户服务协议</h3>
    <p>本平台---海科商户通，是北京海科融通支付服务有限公司（以下简称“本公司”）负责运营的，主要为平台会员代理本公司为第三方产品（以下提及第三方产品包含“服务”）提供推介中介服务，提供展业、查询、提现等功能的服务支持平台，平台的形式包括但不限于APP、网站,以下简称“平台”。</p>
    <p><span class="weight">为了保障您的权益，请于注册或使用本服务前，仔细阅读并完全理解本服务条款的全部内容，其中用粗字体予以标注的，是与您的权益有或可能具有重大关系，及对本公司具有或可能具有免责或限制责任的条款，请您特别注意。</span>您必须不加修改地无条件地完全接受本服务协议所包含的条款、条件和本平台已经发布的各类规则，才能进入用户注册程序。您只有成功注册成为本平台用户后，才能使用本平台提供的用户服务。如您不同意本服务条款的任意条款内容，请勿注册或使用本平台提供的用户服务。您认可，注册为平台用户后根据不同产品的需求需经过资格审核通过后才享有使用本平台具体产品服务的权利。</p>
    <p>第一条 用户的主体资格</p>
    <p><span class="weight">1、本平台只接受具有合法运营资格的机构及持有有效身份证件的18周岁以上的具有完全民事行为能力的自然人成为平台用户。</span>如您不具备上述资格，您应立即停止在本平台的注册程序、停止使用本平台服务；同时，本平台有权随时终止您的注册进程及服务、注销您的账户（本协议提及的“注销账户”“取消用户资格”“终止服务”等词语包含终止本协议及相关网签协议的涵义），您应对您的注册与使用给本平台带来的损失承担赔偿责任，如您为限制民事行为能力或无民事行为能力的自然人，您的监护人应承担相关责任。</p>
    <p>2、在注册时和使用本平台服务的所有期间内，您应提供您自身的真实、最新、有效及完整的信息资料并保证提交的所有资料和信息，在上述期间具有持续的有效性及安全性，持续具有用户资格，否则本平台有权拒绝您的注册申请或终止服务，如造成本平台或其他第三方损失的，您应当承担赔偿责任。</p>
    <p><span class="weight">3、您授权本平台在为您业务办理的过程中自行或为您委托第三方进行实名认证、鉴权等相关认证服务。</span></p>
    <p>第二条 服务内容</p>
    <p>1、本平台专注于竭诚为平台会员代理本公司为第三方产品提供推介中介服务，提供展业、查询、提现等功能的服务支持平台。</p>
    <p>2、基于平台使用的特殊性，您授权的自然人主体使用本平台的行为视为您的行为，您应该为此承担相应的责任。您成功注册成为用户后，可通过您设置的用户名和密码登录本平台，具体服务内容以本平台公布为准。</p>
    <p>第三条 使用须知</p>
    <p>1、您不得利用本平台从事任何违反中国法律、法规、行业规定或侵犯国家利益、社会利益、他人合法权益的活动；不得发送、公布或展示违反中国法律、法规及本协议的内容，任何垃圾、广告推销内容。本平台在发现您从事该等活动时，有权不经通知而立即停止您对本平台的全部或部分功能的使用，删除上述违法内容，注销您的账户并不予任何赔偿。</p>
    <p>2、您在注册时向本平台提交的手机号码、电子邮箱、用户名、密码及安全问题答案等是您在本平台的识别信息。您注册成功后应妥善保管上述识别信息，不得将其转让、授权第三方使用或泄露，如果本平台发现同一账户在同一时间内被多人同时登陆使用，或类似风控规则判定存在账户风险的，本平台有权限制该用户访问直至取消用户资格，并不予任何赔偿。同时，您确认，使用您的用户名和密码等登录本平台后在本平台的一切行为均视为代表您本方意志并由您承担相应的法律后果。</p>
    <p>3、若您发现有他人冒用或盗用您的用户名及密码或任何其他未经合法授权之信息登录时，应立即以有效方式通知本平台，要求暂停相关服务。同时，您理解本平台对您的请求采取行动需要合理期限，而在本平台采取实际行动之前，您应承担任何未经授权人士使用此服务或此服务被用作未经授权用途的不利后果并对其负责，本平台对已执行的指令及所导致的您及任何第三方的损失不承担任何责任。</p>
    <p>4、您保证合法使用本平台提供的服务，未经本平台事先书面授权，不使用任何非法手段擅自进入本平台未公开的系统。</p>
    <p><span class="weight">5、在您使用本平台时，您认可本平台或本平台合法委托的第三方可以通过短信、电子邮件、微信等电子形式向您发送关于本平台或者其他方的广告，或者在任何形式的通知中附带广告或者含有广告的链接。您认可本平台、本公司通过电话营销的形式向您推荐平台相关业务。</span></p>
    <p>第四条 用户信息的合理使用</p>
    <p><span class="weight">1、为您提供平台服务之必须，以及更好地为您提供服务，您同意本平台在业务运营中收集和储存您的用户信息，包括但不限于您自行提供的，本平台在您使用过程中自行合法收集取得的，以及向第三方合法收集的信息。具体内容请查看平台《隐私政策》。</span></p>
    <p><span class="weight">2、您授权本平台委托第三方进行网签协议的签署，并由第三方进行网签协议的存证工作。</span></p>
    <p><span class="weight">您认可电子签章记载时间为网签协议签署时间，且认可经过电子签章的网签协议的完全效力，不得以非纸质协议或协议可被篡改等为理由否认其效力。</span></p>
    <p>第五条 服务费提现及提现手续费</p>
    <p><span class="weight">1、绑卡：您进行服务费等应收账款提现操作前，需要在平台操作绑定您的银行卡作为收款卡，绑定时您应按照平台规则进行银行卡鉴权。</span></p>
    <p><span class="weight">您保证您的账户的准确性，并不得在未通知平台的情况下擅自更换，由此造成的账款不到账等任何后果由您自行承担。</span></p>
    <p>2、提现手续费：您提现己方的服务费时，平台将向您收取提现手续费。该手续费将在您提现时予以坐扣。</p>
    <p>提现手续费=提现款项金额×手续费费率。具体提现手续费费率详见本平台公示。</p>
    <p>3、服务费发票：如您选择开票功能，您将在平台合作的第三方税筹平台进行开户，并使用该方代付与开票服务。如您选择不开票功能，平台直接为您进行服务费下发。选择是否开票功能的不同，提现手续费的标准不同。</p>
    <p><span class="weight">4、提现手续费发票：提现手续费为不含税价，故平台无需为您开具手续费发票。</span></p>
    <p><span class="weight">第六条 用户的承诺和保证</span></p>
    <p><span class="weight">1、本平台用户应保证严格遵守中国现行法律、法规、政府规章及其他应该遵守的规范性文件，不从事危害国家安全、洗钱、套现、传销等任何违法活动或者其他有违社会公共利益或公共道德的行为。您作为平台用户，您保证您经营活动和经营范围的合法性。同时，您将不会利用本服务从事侵害本公司、他人合法权益之行为，以及进行任何违法或不正当的活动，否则本公司有权拒绝提供服务，且您应承担因此产生的一切责任；本公司、本公司雇员或任何第三方合法权益因此受损的，您应承担损害赔偿责任。具体要求如下：</span></p>
    <p><span class="weight">（1）严格遵守国家法律法规、监管部门规定以及公司管理要求，在本公司的业务范围内合法合规地开展业务；</span></p>
    <p><span class="weight">（2）全部行为符合《中华人民共和国广告法》及相关规定，真实、健康地开展业务，不得含有虚假或者引人误解的内容，不得欺骗、误导他人，且不得使用含有“套现”“透支”“薅羊毛”等违法违规的宣传内容。</span></p>
    <p><span class="weight">（3）全部行为符合《中华人民共和国反不正当竞争法》《中华人民共和国消费者权益保护法》及相关规定，禁止采取扰乱市场竞争秩序，损害其他经营者或者消费者的合法权益的行为。</span></p>
    <p><span class="weight">（4）时刻维护本公司良好声誉与合法权益，且不得超过本公司授权范围开展业务。</span></p>
    <p><span class="weight">（5）严格按照活动说明进行推荐，不得推荐不符合要求的用户或擅自、合谋套取活动奖励与报酬。</span></p>
    <p><span class="weight">（6）禁止设点公开推广或网络公开推广，发展下级、多级开展业务，拉人头，收取入会费等违法违规行为。</span></p>
    <p><span class="weight">（7）禁止保存用户的个人信息，如侵犯他人个人信息的，由本人承担责任。</span></p>
    <p><span class="weight">（8）禁止其他一切违法、违规、违约等不当行为。</span></p>
    <p><span class="weight">2、您认可，本公司实时对您使用平台服务的动态进行监督和检查，如发现您有违反国家法律、法规规定、行业规定或本协议约定的，有权立即暂停、终止服务、注销您的账户。 </span></p>
    <p><span class="weight">3、基于平台业务，本人与其他方之间产生的任何纠纷均由本人负责妥善处理，与本公司无关。由此给本公司、产品方造成的一切损失，由本人承担。</span></p>
    <p><span class="weight">会员之间就平台业务存在任何纠纷的，由双方自行解决，与平台无关。造成本公司损失的，由该双方承担连带赔偿责任。</span></p>
    <p><span class="weight">4、如您使用第三方税筹平台进行代付，有关该税筹平台向您收取的手续费及手续费发票事宜、代开发票事宜、代扣代缴税收等事宜由您与税筹平台约定，与本平台无关，如您们之间发生纠纷，本平台无义务与责任参与与负责解决。同时，您保证您履行您与税筹平台之间的任何约定不违背您与本平台的任何协议约定，且不侵犯本平台的任何权益。</span></p>
    <p>您认可，您给本公司造成损失的，赔偿责任包括但不限于实际损失、行政罚金、律师费、诉讼费、公证费、食宿费，相关损失本公司有权从服务费中扣除。</p>
    <p><span class="weight">5、风险承担</span></p>
    <p><span class="weight">5.1信息泄露风险：因您的信息及使用者个人信息和资料被不法分子窃取、泄露的风险以及由此带来的隐私、生活受到干扰、侵犯的风险；</span></p>
    <p><span class="weight">5.2服务中断风险：由于互联网相关服务具有特殊性，因本平台、相关第三方的设备系统维护；通讯故障、设备故障、电力中断、网络故障、黑客攻击、计算机病毒攻击及其他公司不可控制情况的影响，可能导致服务中断；</span></p>
    <p><span class="weight">5.3不可抗力风险：地震、台风、水灾、海啸、雷电、火灾、瘟疫、病毒、流行病、战争、恐怖主义、敌对行为、暴动、罢工、交通中断、经济形势严重恶化或其它类似事件导致的风险等。</span></p>
    <p><span class="weight">5.4操作风险</span></p>
    <p><span class="weight">如果您缺乏必要的互联网经验，可能出现因操作不当导致损失；如果您未能谨慎保管自己的账号和密码，或者设置的密码简单导致密码被破解，以及您在进行资金交易时未能确保所使用的操作终端、网络以及周围环境的安全性，导致账号和密码被他人盗取、使用，可能导致违反您本人意愿的损失。由于本平台以账号和密码等要素进行身份识别，一切以您认证方式进行的操作等均被视为您本人的操作，您将对此发生的一切后果承担全部责任。</span></p>
    <p><span class="weight">5.5其他风险。</span></p>
    <p><span class="weight">第七条 免责声明</span></p>
    <p><span class="weight">1、除非另有书面协议约定，本平台在任何情况下（平台具备侵权的全部要素或者平台违约导致的除外），对用户使用本平台服务而产生的任何形式的直接或间接损失均不承担法律责任，包括但不限于资金损失。</span></p>
    <p><span class="weight">2、本平台对于您与任何主体达成协议约定而导致的任何纠纷不承担任何责任。</span></p>
    <p><span class="weight">3、任何本平台之外的第三方机构或个人所提供的服务，其服务品质及内容、纠纷由该第三方自行、独立负责，与本平台无关。</span></p>
    <p><span class="weight">第八条 网签协议的效力及有效期</span></p>
    <p>1、本平台提及的“网签协议”包括但不限于平台协议、平台发布的公告、声明、承诺、通知等文件。</p>
    <p><span class="weight">2、用户一旦点击确认或以类似方式同意了本平台的协议，即代表该文件即刻生效。用户在此承诺不会以未阅读或未知晓该内容作任何形式的抗辩，也不得以未签署书面协议为由否认协议的效力。如在协议签署前，用户对协议内容有任何异议请不要签署并停止使用该产品，否则，视为认可该协议的效力，后期不会以此为由否认其效力。</span></p>
    <p><span class="weight">3、平台发布的公告、声明、承诺、通知等法律文件也属于“网签协议”的范畴，如您对其内容有任何异议请停止使用该产品，否则，视为认可文件的效力，后期不会以此为由否认其效力。</span></p>
    <p>4、本协议的有效期为自本协议签署之日至网签协议履行完毕，全部责任、义务履行完毕时，且平台账户注销之日止。</p>
    <p>第九条 用户注销、暂停、终止或限制访问</p>
    <p>1、如您六个月内无用户账户操作且用户账户无余额，您的用户账户进入为期六个月的休眠期，休眠期结束后用户账户自动注销。休眠期内用户账户有任何操作或入账，用户账户正常使用。</p>
    <p>2、如果您决定不再使用本平台服务时，应首先完成所有义务，保证与相关方无任何争议以及遗留问题，并向本平台申请注销该账户，经本平台审核同意后方可正式注销您的账户。</p>
    <p>3、本平台有权基于单方独立判断，在认为可能发生危害交易安全等风险情形时，不经通知而先行暂停、中断或终止向您提供本协议项下的全部或部分用户服务，并将注册资料移除或删除，且无需对您或任何第三方承担任何责任。</p>
    <p>4、只要您利用本平台从事违法、违规活动或者违反本协议、其他网签协议的约定，本平台可在不发出任何通知的情况下立即限制您的访问、使您的账户无效，或撤销您的账户以及您的账户内的所有相关资料和档案，直接终止本协议。账号终止后，本平台没有义务为您保留原账号中任何信息，或转发任何未曾阅读或发送的信息给您或第三方。此外，本平台亦不会就终止您的账户使用而对您或任何第三者承担任何责任。</p>
    <p>5、您的账户的暂停、中断或终止不代表用户责任的终止，用户仍应对其使用本平台提供服务期间的行为承担后续义务及相关的违约或损害赔偿责任，同时本平台有权永久存储相关信息。</p>
    <p>第十条 知识产权保护</p>
    <p>本平台所有内容和服务，包括但不限于平台的整体结构、网页设计、文字、图片、图表、软件、视频文件、音频文件、源代码、广告以及本平台为用户提供的其它信息或资料，以及支撑前述服务和内容的技术秘密与商业秘密，其知识产权均属本平台或相关权利方（如有）所有。未经本平台书面许可，任何人不得为了任何目的进行复制、变造、反向工程或者以其它方式进行非法使用。</p>
    <p>第十一条 赔偿</p>
    <p>1、用户因违反本协议或其他网签协议，或违反了任何法律、法规的规定，给本平台造成损失的，应予赔偿，赔偿范围包括但不限于本平台的直接损失、间接损失以及维权费用（“维权费用”包括但不限于律师费、公证费、取证费、交通费、食宿费）。</p>
    <p>2、用户因违反前款规定而侵害了第三方的权利，导致本平台遭受任何第三方提起的索赔、诉讼、仲裁或引发行政责任的，用户承诺无条件承担相应责任并使本平台免责。若因此给本平台造成损失的，用户应予赔偿，赔偿范围包括但不限于本平台的维权费用、名誉损失以及本平台向第三方支付的赔偿金、缴纳的行政罚金。</p>
    <p>第十二条 送达与信息变更</p>
    <p>1、您认可您提供给平台的信息即为有效的送达方式及送达地址，送达内容包括但不限于平台的通知、公函、权力机关的文书；送达方式包括但不限于公告（涉及隐私、秘密的除外）、站内信、短信、邮件、传真、邮寄。其中，公告、站内信、短信的送达方式，一经发出视为送达。</p>
    <p>2、用户如变更了提供给平台的信息，须及时通知本平台，否则仍视为有效的送达地址。因您未及时通知而导致自身、本平台及第三方受到的一切损失，由您自行承担，如因此给本平台造成损失的，本平台有权向您追偿。</p>
    <p>第十三条 争议的处理</p>
    <p>本协议在履行过程中，如发生任何争执或纠纷，双方应友好协商解决，协商不成的，任何一方有权向本公司所在地人民法院提起诉讼解决。</p>
    <p>第十四条 其他</p>
    <p>1、本协议中的任何条款或部分条款因违反中国法律而无效的，不影响本协议其他条款的效力。</p>
    <p><span class="weight">2、您同意本平台因为服务项目变更、公司业务变更或法律法规、监管要求、国家政策变更等原因修改本协议以及平台所有网签协议等，修改将以平台公告、短信通知、站内信等形式进行，协议修改后您可以根据意愿选择是否同意，如不同意应停止使用本平台，否则视为同意修改。如因业务模式的限制，导致无法立即终止使用本平台的，您同意届时认可上述协议的修改并履行完毕相应义务。</span></p>
    <p><span class="weight">3、您作为本平台的用户，有义务随时关注本平台公示信息、通知、站内信、网签协议等，上述内容一经刊登、发送即生效，您不得以未阅读、未收到或未确认与签署为由否认其效力。</span></p>
    <p>4、如有关内容其他网签协议未约定，适用本协议约定的相关内容。</p>
    <img src="../../assets/img/backPic.png" @click="back" class="pic" v-if="entryMode">
  </div>
</template>

<script>
export default {
    data() {
      return {
        entryMode: "" //判断是怎么进来的
      }
    },
    created () {
      document.title = "用户服务协议"
      let entryMode = this.$route.query.entryMode;//判断来源
      if(!!entryMode){
        this.entryMode = entryMode;
      }
    },
    methods: {
      back() {
        if(this.entryMode == 'backs'){
          this.$router.push({
            name: "registForRedEnvelopes",
            query: {
              isBack: "0000",
              commendCode:this.$route.query.commendCode,
              activeCode:this.$route.query.activeCode
            }
          })
        }else{
          this.$router.push({
            name: "mxkShare",
            query: {
              isBack: "0000"
            }
          })
        }
      }
    },
};
</script>

<style scoped>
.wrap{
    padding: 0 10px;
    padding-bottom: 20px;
}
.title{
    text-align: center;
    padding: 10px 0;
}
.weight {
  font-weight: bold;
}
p{
    line-height: 30px;
}
.subTitle{
    line-height: 28px;
    margin-top: 10px;
}
.pic{
    position: fixed;
    left: 0;
    bottom: 40%;
    opacity: .7;
}
</style>